module.exports = __webpack_public_path__ + "img/karty_bdo_inactive.51246536.svg";